export default __webpack_public_path__ + "static/bring-federal-funding-back-to-rhode-island-hero-8907b38ad37338ab11c79fdebb5be115.webp";